import { render } from "./MobilePoleView.vue?vue&type=template&id=e01b4608"
import script from "./MobilePoleView.vue?vue&type=script&lang=js"
export * from "./MobilePoleView.vue?vue&type=script&lang=js"
script.render = render

export default script